import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class ChangePhoneService {
  
  constructor(private http: HttpClient) {}

  addUpdatePhone(email, phoneNumber) {
    const url = `${environment.backend_server_url_account}/change-phone?email=${email}&phone=${phoneNumber}`;
    return this.http.put(url, {});
  }
}
